import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Beauty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render () {
    return (
      <div class="">
        <Helmet>
          <title>Онлайн-запись для салона красоты и массажа – Бесплатная CRM | Planna</title>
          <meta name="description" content="Автоматизируйте запись клиентов в салон, барбершоп, массажную студию. Напоминания, единый календарь сотрудников, QR-код. Бесплатно навсегда." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>

<section class="hero">
    <div class="container fade-up">
        <div class="hero-badge">✨ Бизнес-решение | Бесплатно навсегда</div>
        <h1>Онлайн-запись и CRM<br/>для <span class="highlight">салонов красоты, массажа и барбершопов</span></h1>
        <p style={{fontSize: "1.2rem", color: "#4B5563", maxWidth: "700px", margin: "1.5rem 0 2rem"}}>Замените тетрадку и звонки. Клиенты записываются 24/7, мастера видят расписание, напоминания снижают неявки на 70%.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить бизнес бесплатно <i className="fas fa-play"></i></a>
            </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="fade-up" style={{textAlign: "center"}}>
            <h2 class="section-title">Всё, что нужно для вашего бизнеса</h2>
            <p class="section-subtitle">Автоматизируйте запись, повышайте лояльность и не теряйте клиентов</p>
        </div>
        <div class="grid-3 fade-up">
            <div class="benefit-card"><i class="fas fa-calendar-check benefit-icon"></i><h3>Онлайн-запись 24/7</h3><p>Клиенты сами выбирают услугу, мастера и время. QR-код для стенда и соцсетей.</p></div>
            <div class="benefit-card"><i class="fas fa-phone-alt benefit-icon"></i><h3>Запись по телефону</h3><p>Администратор вносит бронь вручную за 10 секунд. Всё в одном календаре.</p></div>
            <div class="benefit-card"><i class="fas fa-users benefit-icon"></i><h3>Единый календарь сотрудников</h3><p>Каждый мастер видит своё расписание. Интеграция с личными делами — никаких конфликтов.</p></div>
            <div class="benefit-card"><i class="fas fa-bell benefit-icon"></i><h3>Автоматические напоминания</h3><p>SMS, Telegram, push – снижаем неявки до 70%. Клиенты не забывают.</p></div>
            <div class="benefit-card"><i class="fas fa-hand-holding-usd benefit-icon"></i><h3>Дополнительные услуги при записи</h3><p>Клиент выбирает опции (тонирование, спа-уход) и видит итоговую цену. Чек растёт.</p></div>
            <div class="benefit-card"><i class="fas fa-chart-line benefit-icon"></i><h3>Аналитика и отчёты</h3><p>Загрузка мастеров, популярные услуги, средний чек — полный контроль.</p></div>
        </div>
    </div>
</section>

<section style={{background: "#F9FAFB"}}>
    <div class="container">
        <div class="fade-up" style={{textAlign: "center"}}>
            <h2 class="section-title">Как это работает на деле</h2>
            <p class="section-subtitle">Просто и интуитивно — ваши клиенты будут в восторге</p>
        </div>
        <div class="grid-2 fade-up" style={{gap: "2.5rem"}}>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}combined1.png" alt="Скриншот календаря"/>
                <div class="mockup-label">📅 Единое расписание мастеров</div>
            </div>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}addservice1.png" alt="Выбор дополнительных услуг"/>
                <div class="mockup-label">✨ Добавление опций при бронировании</div>
            </div>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}qrcode1.png" alt="QR-код"/>
                <div class="mockup-label">📱 QR-код — запись за секунду</div>
            </div>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}notification1.png" alt="Напоминание"/>
                <div class="mockup-label">🔔 Напоминания в push, Telegram/SMS</div>
            </div>
        </div>
    </div>
</section>

<div class="qr-block fade-up" style={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: "2rem", marginTop: 0}}>
    <div style={{flex: "1"}}>
        <i class="fas fa-bell" style={{fontSize: "2.5rem", color: "#32bea6", marginBottom: "1rem", display: "inline-block"}}></i>
        <h3 style={{fontSize: "1.8rem", fontWeight: "700"}}>Не упустите ни одного клиента</h3>
        <p style={{margin: "1rem 0", color: "#374151"}}>Если все слоты у мастера заняты, клиент может <strong>подписаться на освобождение времени</strong>. Как только кто-то отменит запись или перенесёт — система мгновенно оповестит клиента, и он сможет забронировать свободный слот.</p>
        <ul style={{listStyle: "none", marginTop: "1rem"}}>
            <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Автоматические уведомления в Telegram, SMS, push</li>
            <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Клиент занимает место первым — вы не теряете выручку</li>
            <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Снижение «окон» в расписании</li>
        </ul>
    </div>
    <div style={{flex: "1"}}>
        <div class="screenshot-placeholder">
            <img src="{{mainApiUrl}}subscription1.png" alt="Подписка на освободившиеся слоты"/>
            <div class="mockup-label">🔔 Клиент подписывается – вы заполняете слот</div>
        </div>
    </div>
</div>

<div class="qr-block fade-up" style={{background: "#FFFFFF", border: "1px solid rgba(50,190,166,0.3)", marginTop: "2rem"}}>
    <div style={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: "2rem"}}>
        <div style={{flex: "1.2"}}>
            <i class="fas fa-calendar-alt" style={{fontSize: "2.5rem", color: "#32bea6", marginBottom: "1rem", display: "inline-block"}}></i>
            <h3 style={{fontSize: "1.8rem", fontWeight: "700"}}>Клиент видит загрузку мастера и выбирает свободное время</h3>
            <p style={{margin: "1rem 0", color: "#374151"}}>Перед записью клиент видит <strong>реальную загрузку каждого мастера</strong> и всего салона в удобном календаре. Свободные слоты подсвечены, занятые – затемнены. Клиент может отфильтровать по длительности услуги: например, найти окно ровно на 1 час или 30 минут.</p>
            <ul style={{listStyle: "none", marginTop: "1rem"}}>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Наглядная цветовая индикация загрузки по дням</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Фильтр по длительности услуги – подбор под свободное время мастера</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Клиент видит, когда у мастера «окно» – и записывается сам</li>
            </ul>
        </div>
        <div style={{flex: "0.9"}}>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}calendar1.png" alt="Календарь загрузки мастера"/>
                <div class="mockup-label">📊 Загрузка мастера по часам и дням</div>
            </div>
        </div>
    </div>
</div>

<div class="qr-block fade-up" style={{background: "linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)", marginTop: "2rem"}}>
    <div style={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: "2rem"}}>
        <div style={{flex: "1.2"}}>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}combined2.png" alt="Объединённый календарь"/>
                <div class="mockup-label">📅 Два календаря – один выбор</div>
            </div>
        </div>
        <div style={{flex: "1.2"}}>
            <i class="fas fa-eye" style={{fontSize: "2.5rem", color: "#32bea6", marginBottom: "1rem", display: "inline-block"}}></i>
            <h3 style={{fontSize: "1.8rem", fontWeight: "700"}}>При бронировании — два календаря рядом</h3>
            <p style={{margin: "1rem 0", color: "#374151"}}>Система показывает клиенту одновременно его личные события (из Google, Apple или Яндекс.Календаря) и свободные слоты мастера. Клиент сразу видит, когда он занят, и выбирает только то время, которое подходит обоим. <strong>Никакой синхронизации и записи в календарь клиента не происходит</strong> — только чтение, только для удобства выбора.</p>
            <ul style={{listStyle: "none", marginTop: "1rem"}}>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Клиент видит своё расписание и расписание салона в одном окне</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Система автоматически подсвечивает конфликтующие слоты – двойных бронирований не будет</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Календарь клиента остаётся приватным – мы только читаем, ничего не записываем</li>
            </ul>
        </div>
    </div>
</div>

<div class="qr-block fade-up" style={{background: "#FFFFFF", border: "1px solid rgba(50,190,166,0.3)", marginTop: "2rem"}}>
    <div style={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: "2rem"}}>
        <div style={{flex: "1.2"}}>
            <i class="fas fa-chart-line" style={{fontSize: "2.5rem", color: "#32bea6", marginBottom: "1rem", display: "inline-block"}}></i>
            <h3 style={{fontSize: "1.8rem", fontWeight: "700"}}>Выберите самый свободный день</h3>
            <p style={{margin: "1rem 0", color: "#374151"}}>При выборе даты клиент видит <strong>календарь месяца с цветовой индикацией загрузки салона</strong>. Зелёные дни – наименее загруженные, красные – пиковая загрузка. Клиент может запланировать визит в спокойное время, когда мастер будет максимально внимателен.</p>
            <ul style={{listStyle: "none", marginTop: "1rem"}}>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Визуальная шкала загрузки: от зелёного (свободно) до красного (много записей)</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Клиент сам выбирает удобный день – меньше отказов и неявок</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Равномерное распределение нагрузки на мастеров</li>
            </ul>
        </div>
        <div style={{flex: "0.9"}}>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}calendar1.png" alt="Календарь загрузки салона по дням"/>
                <div class="mockup-label">📅 Зелёный – свободно, красный – пик</div>
            </div>
        </div>
    </div>
</div>

<div class="qr-block fade-up" style={{background: "linear-gradient(110deg, rgba(50,190,166,0.08) 0%, #FFFFFF 100%)", margin: "2rem 0"}}>
    <div style={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: "2rem"}}>
        <div style={{flex: "1"}}>
            <div class="screenshot-placeholder">
                <img src="{{mainApiUrl}}mobile1.png" alt="Приложения для iOS и Android"/>
                <div class="mockup-label">📱 Управляйте бизнесом со смартфона</div>
            </div>
        </div>
        <div style={{flex: "1.2"}}>
            <i class="fas fa-mobile-alt" style={{fontSize: "2.5rem", color: "#32bea6", marginBottom: "1rem", display: "inline-block"}}></i>
            <h3 style={{fontSize: "1.8rem", fontWeight: "700"}}>Мобильные приложения для всех</h3>
            <p style={{margin: "1rem 0", color: "#374151"}}>Ваши сотрудники и клиенты могут пользоваться сервисом через удобные нативные приложения для iOS и Android.</p>
            <ul style={{listStyle: "none", marginTop: "1rem"}}>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> <strong>Для бизнеса:</strong> принимайте бронирования, управляйте расписанием, получайте уведомления — всё с телефона</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> <strong>Для клиентов:</strong> запись в один клик, календарь, выбор услуг и оплата</li>
                <li><i class="fas fa-check-circle" style={{color: "#32bea6"}}></i> Кроссплатформенность — работайте где угодно</li>
            </ul>
            <div class="app-badges" style={{justifyContent: "flex-start", margin: "20px 0 0 0"}}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: '45px' }} /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png" alt="Google Play" style={{ height: '45px' }} /></a>
            </div>
        </div>
    </div>
</div>

<section>
    <div class="container">
        <div class="qr-block fade-up" style={{display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "2rem"}}>
            <div style={{flex: "1"}}>
                <i class="fas fa-user-friends" style={{fontSize: "2.5rem", color: "#3B82F6", marginBottom: "1rem", display: "inline-block"}}></i>
                <h3 style={{fontSize: "1.8rem", fontWeight: "700"}}>Ищете компанию для спа или парного массажа?</h3>
                <p style={{margin: "1rem 0", color: "#374151"}}>Ваши клиенты могут отметить «ищу партнёра» — система найдёт второго участника. Вы получаете двух клиентов вместо одного. Идеально для массажных студий, спа-центров.</p>
                <a href="#" class="btn-outline" style={{marginTop: "0.5rem"}}>Узнать подробнее →</a>
            </div>
            <div style={{flex: "0.8"}}>
                <div class="screenshot-placeholder" style={{background: "white"}}>
                    <img src="https://placehold.co/400x300/DBEAFE/1E3A8A?text=Поиск+партнёра" alt="Поиск партнера"/>
                </div>
            </div>
        </div>
    </div>
</section>

<section style={{background: "#F8FAFF"}}>
    <div class="container fade-up">
        <h2 class="section-title" style={{textAlign: "center"}}>Для любого формата бизнеса</h2>
        <div class="stats-grid" style={{justifyContent: "center", marginTop: "2rem"}}>
            <div class="benefit-card" style={{background: "white", textAlign: "center", minWidth: "160px"}}><i class="fas fa-cut"></i><h3>Салон красоты</h3><p>3+ мастера, контроль выручки</p></div>
            <div class="benefit-card" style={{background: "white", textAlign: "center", minWidth: "160px"}}><i class="fas fa-hand-sparkles"></i><h3>Массажный кабинет</h3><p>Поиск партнёра + онлайн-запись</p></div>
            <div class="benefit-card" style={{background: "white", textAlign: "center", minWidth: "160px"}}><i class="fas fa-user-tie"></i><h3>Барбершоп</h3><p>Учёт нескольких мастеров</p></div>
            <div class="benefit-card" style={{background: "white", textAlign: "center", minWidth: "160px"}}><i class="fas fa-user-check"></i><h3>Самозанятый мастер</h3><p>Бесплатно, всё в смартфоне</p></div>
        </div>
    </div>
</section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

<section>
    <div class="container fade-up">
        <h2 class="section-title" style={{textAlign: "center"}}>Часто задаваемые вопросы</h2>
        <div style={{maxWidth: "800px", margin: "2rem auto"}}>
            <div class="faq-item">
                <div class="faq-question">❓ Это действительно бесплатно? <i class="fas fa-chevron-down"></i></div>
                <div class="faq-answer">Да. Никакой абонентской платы, процентов с броней. Вы платите только за SMS и комиссию банка за онлайн-оплату (если подключите). Бесплатно навсегда.</div>
            </div>
            <div class="faq-item">
                <div class="faq-question">❓ А если клиент звонит, я могу записать его вручную? <i class="fas fa-chevron-down"></i></div>
                <div class="faq-answer">Да. Администратор или мастер добавляет бронь в календарь за 10 секунд. Напоминания, учёт — всё автоматически.</div>
            </div>
            <div class="faq-item">
                <div class="faq-question">❓ Нужно ли мастерам устанавливать приложение? <i class="fas fa-chevron-down"></i></div>
                <div class="faq-answer">Нет, достаточно браузера на телефоне. Нет, достаточно браузера на телефоне. Каждый сотрудник видит своё расписание, может записывать к себе клиентов, получать уведомления, но в приложении больше возможностей</div>
            </div>
            <div class="faq-item">
                <div class="faq-question">❓ Как клиенты могут добавить дополнительные услуги? <i class="fas fa-chevron-down"></i></div>
                <div class="faq-answer">При онлайн-записи клиент видит список допов с ценами, отмечает нужные — итоговая сумма обновляется мгновенно. Больше средний чек.</div>
            </div>
            <div class="faq-item">
                <div class="faq-question">❓ Можно ли вносить записи на несколько дней вперёд? <i class="fas fa-chevron-down"></i></div>
                <div class="faq-answer">Да, календарь позволяет планировать на месяцы вперёд, с блокировкой выходных и перерывов мастеров.</div>
            </div>
        </div>
    </div>
</section>

<section style={{background: "linear-gradient(115deg, #1E3A8A 0%, #3B82F6 100%)", color: "white", borderRadius: "0"}}>
    <div class="container fade-up" style={{textAlign: "center"}}>
        <h2 style={{fontSize: "2.2rem", fontWeight: "800"}}>Начните принимать онлайн-запись уже сегодня</h2>
        <p style={{fontSize: "1.1rem", margin: "1rem auto 2rem", maxWidth: "600px", opacity: "0.9"}}>Перестаньте терять клиентов из-за занятого телефона и путаницы в расписании.</p>
        <a href="/configcompany" class="btn-filled" style={{background: "white", color: "#1E3A8A", boxShadow: "none"}}>Подключить бизнес бесплатно <i class="fas fa-arrow-right"></i></a>
        <p style={{marginTop: "2rem", fontSize: "0.9rem"}}>Настройка за 15 минут. QR-код, напоминания, аналитика — 0₽</p>
    </div>
</section>


      </div>
    );
  }
}
